<peab-grid>
  <peab-grid-cell columns="6">
  <peab-warning>
    <mat-icon>warning</mat-icon>
    <peab-header>
      {{ translations.siteErrorInfoHeader | translate }}
    </peab-header>
    <peab-text>
      {{ translations.siteErrorInfoText | translate }}
    </peab-text>
  </peab-warning>
    <peab-header>
      {{ translations.passwordReset | translate }}
    </peab-header>
    <peab-text>
      {{ translations.description | translate }}
    </peab-text>
    <app-stepper></app-stepper>
  </peab-grid-cell>
</peab-grid>
